const $ = jQuery;
const $window = $(window);

const initOverlay = () => {
  const els = once('lang-overlay', '.om-language-overlay');
  els.forEach((el) => {
    const $this = $(el);
    const $darkOverlay = $this.find('.om-overlay');
    const $langClose = $this.find('.om-overlay-close');

    const $langDropdown = $('.deutsch');
    const body = $('body');
    const $mainNav = $('.om-navigation');

    if (drupalSettings.user.uid === 0) {
      $langDropdown.on('click', function (event) {
        event.preventDefault();
        // If we know that it's a mobile dropdown, nav is open, therefore we close it.
        if ($(this).parents().hasClass('om-lang-switch-mobile-wrapper')) {
          body.removeClass('om-nav-active');
          $mainNav.hide();
        }
        $this.css('display', 'flex');
      });

      $darkOverlay.add($langClose).on('click', () => $this.hide());
    }
  });
};

$window.on('load', () => initOverlay());
